import { AmplifyUser } from "@aws-amplify/ui";
import { Quotation } from "../types/quotations/Quotation";
import { getHeader } from "./user";
import axios from "axios";
import { Extra } from "../types/quotations/Extra";
import { errorToast } from "@idwal/idwal-react-components";
import { OrgQuotations } from "../types/quotations/QuotationsState";

export interface GetQuotationsRequestDto {
    orgIds: string[],
    user: AmplifyUser,
    statuses?: number[]
}

export interface GetQuotationRequestDto {
    quotationId: string,
    user: AmplifyUser
}

export interface AddQuotationExtraRequestDto {
    quotationId: string,
    updatedExtraId: number,
    user: AmplifyUser
}

export interface DeleteQuotationExtraRequestDto {
    quotationId: string,
    quotationExtraId: number,
    user: AmplifyUser
}

export const getQuotationsByOrgId = async (requestData: GetQuotationsRequestDto): Promise<OrgQuotations> => {
    const url = process.env.REACT_APP_IDWAL_API_URL + "/CustomerPortal/Quotations";
    let quotationData: Quotation[] = [];

    try {
        const token = requestData.user.getSignInUserSession()?.getIdToken();
        if (!token) {
            throw new Error("No token");
        }

        const header = await getHeader();

        const result = await axios.post(
            url,
            {
                orgIds: requestData.orgIds,
                quotationStatus: requestData.statuses,
                page: 1,
                dateStart: "",
                dateEnd: ""
            },
            {
                headers: header
            }
        );
        if (!result.data || result.data.length === 0) {
            throw new Error("No data");
        }

        quotationData = result.data;
        return Promise.resolve({
            OrgIds: requestData.orgIds,
            Quotations: quotationData
        });
    } catch (err: any) {
        throw new Error(err);
    }
};

export const getQuotationById = async (requestData: GetQuotationRequestDto): Promise<Quotation> => {
    const url = process.env.REACT_APP_IDWAL_API_URL + `/CustomerPortal/Quotations/${requestData.quotationId}`;

    try {
        const token = requestData.user.getSignInUserSession()?.getIdToken();
        if (!token) {
            throw new Error("No token");
        }

        const header = await getHeader();

        const result = await axios.get(url, {
            headers: header
        });

        if (!result.data) {
            throw new Error("No data");
        }

        return Promise.resolve(result.data);
    } catch (err: any) {
        throw new Error(err);
    }
}

export const getQuotationExtras = async (requestData: GetQuotationRequestDto): Promise<Extra[]> => {
    const url = process.env.REACT_APP_QUOTATION_API_ENDPOINT + `/quotation/${requestData.quotationId}/extras`;

    try {
        const token = requestData.user.getSignInUserSession()?.getIdToken();
        if (!token) {
            throw new Error("No token");
        }

        const header = await getHeader();

        const result = await axios.get(url, {
            headers: header
        });

        if (!result.data) {
            throw new Error("No data");
        }

        return Promise.resolve(result.data);
    } catch (err: any) {
        throw new Error(err);
    }
}

export const addQuotationExtra = async (requestData: AddQuotationExtraRequestDto): Promise<Extra> => {
    const url = process.env.REACT_APP_QUOTATION_API_ENDPOINT + `/quotation/${requestData.quotationId}/extras?extraServiceId=${requestData.updatedExtraId}`;

    try {
        const token = requestData.user.getSignInUserSession()?.getIdToken();
        if (!token) {
            throw new Error("No token");
        }

        const header = await getHeader();

        const result = await axios.put(url, {}, {
            headers: header
        });

        if (!result.data) {
            throw new Error("No data");
        }

        return Promise.resolve(result.data);
    } catch (err: any) {
        errorToast("Failed to add new Extra to Quotation");
        throw new Error(err);
    }
}

export const deleteQuotationExtra = async (requestData: DeleteQuotationExtraRequestDto): Promise<any> => {
    const url = process.env.REACT_APP_QUOTATION_API_ENDPOINT + `/quotation/${requestData.quotationId}/extras`;

    try {
        const token = requestData.user.getSignInUserSession()?.getIdToken();
        if (!token) {
            throw new Error("No token");
        }

        const header = await getHeader();

        const result = await axios.delete(url, {
            headers: header,
            data: [requestData.quotationExtraId]
        });

        if (!result.data) {
            throw new Error("No data");
        }

        return Promise.resolve(result.data);
    } catch (err: any) {
        errorToast("Failed to delete Extra from Quotation")
        throw new Error(err);
    }
}

export const getFlagUrl = (flagCode: string) => {
    return `https://quotation.idwalmarine.com/images/flags/${flagCode.toLowerCase()}.svg`;
}